module.exports = __webpack_public_path__ + "static/media/sidebar-supervisor.b984ae90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-supervisor.svg
// module id = 803
// module chunks = 0